import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { Tag } from "primereact/tag";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Api } from "../../../services/api";
import { getLocal } from "../../../utils/localStorageOps";
// import SimpleLoading from "../../../components/SimpleLoading";
import Axios from "axios";
import classNames from "classnames";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { ProgressBar } from "primereact/progressbar";
import { BiRefresh } from "react-icons/bi";
import { FaCamera } from "react-icons/fa";
import WebCamDialog from "../../../components/signup/dialogWebCam";
import { DropdownPague, FloatLabelNumber, InputNumberPague } from "../../../styles/primeReactConfig";
//import Webcam from "react-webcam";

function ZoopCadastro() {
  const fileInput = useRef();

  const navigate = useNavigate();
  const [selfie, setSelfie] = useState(true);
  const [identificacao, setIdentificacao] = useState(false);
  const [residencia, setResidencia] = useState(false);
  const [cnpj, setCnpj] = useState(false);
  const [atividade, setAtividade] = useState(false);
  const [dadosBancarios, setDadosBancarios] = useState(false)
  const [mensagemFim, setMensagemFim] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documentosEnviados, setDocumentosEnviados] = useState([]);
  const [numeroBanco, setNumeroBanco] = useState()
  const [numeroAgencia, setNumeroAgencia] = useState()
  const [numeroConta, setNumeroConta] = useState()
  const [bankList, setBankList] = useState()
  const [showSelfie, setShowSelfie] = useState(false);
  const [onlyOneItemRule, setOnlyOneItemRule] = useState(false);
  const CPF = getLocal('documentocadastro').length === 11;
  const usuario_id = getLocal('usuario_id');

  const handleDocumentUpload = async Data => {
    const knowType = Data.files[0].name.split('.')
    const size = knowType.length
    const fileType = knowType[size - 1]
    // console.log(fileType)
    if (fileType === "jpeg" || fileType === "pdf" || fileType === "jpg") {
      // if(fileType === "jpg"){
      //     const typeJpeg = ".jpeg"
      //     console.log(Data)
      //     Data.files[0].name = (Data.files[0].name.split('.')).concat(typeJpeg)
      // }
      const categoria = Categoria()
      const formData = new FormData();
      const zoop_id = getLocal('zoop_id');
      setLoading(true)
      formData.append('seller_id', zoop_id);
      formData.append('file', Data.files[0]);
      formData.append('category', categoria);
      formData.append('usuario_id', usuario_id);

      try {
        await Api.post(
          '/zoop/documentprovider/create',
          formData,
        );
        if (categoria === 'cnpj') {
          formData.set('category', 'atividade')

          await Api.post(
            '/zoop/documentprovider/create',
            formData,
          );

        }
        setOnlyOneItemRule(false)
        const histDoc = documentosEnviados
        histDoc.push(categoria)
        setDocumentosEnviados(histDoc)

        toast.success('Documento enviado.');
        if (identificacao) {
          setIdentificacao(false);
          setResidencia(true);
        }
        if (residencia) {
          if (CPF) {
            setResidencia(false);
            setAtividade(true);
          } else {
            setResidencia(false);
            setCnpj(true);
          }
        }
        if (cnpj || atividade) {
          setCnpj(false);
          setAtividade(false);
          setDadosBancarios(true);
        }
      } catch (error) {
        console.error(error);
        toast.error(
          'Ocorreu um erro ao enviar o documento. Tente novamente mais tarde.',
        );
      }
      finally {
        setLoading(false);
      }
    } else
      toast.error("O formato do arquivo não é válido, por favor envie em .pdf ou .jpeg, .jpg")
  };


  const handleSelfieUpload = async (file) => {

    const categoria = 'selfie'
    const formData = new FormData();
    const zoop_id = getLocal('zoop_id');
    formData.append('seller_id', zoop_id);
    // if(fileType === "jpg"){
    //     const typeJpeg = ".jpeg"
    //     console.log(file)
    //     const filereader = new FileReader()
    //     const array = filereader.readAsArrayBuffer(await fetch(file.objectURL))
    //     const blob = new Blob(array,{type:"image/jpeg"})
    //     const jpgCorno = new File(blob, (file.name.split('.')).concat(typeJpeg), {type:"image/jpeg"})
    //     console.log(jpgCorno)
    //     formData.append('file', jpgCorno)
    // } else
    formData.append('file', file);
    formData.append('category', categoria);
    formData.append('usuario_id', usuario_id);


    try {
      await Api.post(
        '/zoop/documentprovider/create',
        formData,
      );
      setOnlyOneItemRule(false)
      const histDoc = documentosEnviados
      histDoc.push(categoria)
      setDocumentosEnviados(histDoc)
      toast.success('Documento enviado.');
      setShowSelfie(false)
      setSelfie(false);
      setIdentificacao(true);
    } catch (error) {
      console.error(error);
      toast.error(
        'Ocorreu um erro ao enviar o documento. Tente novamente mais tarde.',
      );
    }
    finally {
      setLoading(false);
    }
  }

  function Categoria() {
    if (selfie)
      return 'selfie'
    if (identificacao)
      return 'identificacao'
    if (residencia)
      return 'residencia'
    if (cnpj)
      return 'cnpj'
    if (atividade)
      return 'atividade'
  }

  function itemTemplate(file, props) {
    return (
      <div className="flex justify-center ">
        <div style={{ display: 'grid', width: window.innerWidth > 810 ? "20vw" : "60vw" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            //width={'50%'}
            style={{
              width: 'inherit',
              maxHeight: window.innerWidth > 810 ? '40vh' : '100vh',
              justifySelf: 'center'
            }}
            className={classNames({ 'hidden': !file.objectURL })}
          />
          <div className="flex text-center justify-center mt-2">
            {file.name}
            <Tag
              value={props.formatSize} severity="info" className="p-px-3 ml-6 p-py-2" />
          </div>
        </div>
      </div>
    )
  }

  const addBankAccount = async () => {
    //event.preventDefault();
    // const email = getLocal('emailcadastro')
    // const senha = getLocal('passwordcadastro')
    const usuario_documento = getLocal('documentocadastro')
    //let token = ''
    setLoading(true);
    // try {
    //     const {data} = await Api.post('/login',{
    //     usuario_email: email,
    //     password: senha
    //     })
    // login(data.token)
    // token = data.token
    // } catch (error) {
    //     toast.error('Erro ao salvar conta bancaria')
    // }
    if (numeroBanco && numeroAgencia && numeroConta) {
      try {
        await Api.post('/contadigital/cadastrar/cadastro3', {
          usuario_id: usuario_id,
          usuario_documento: usuario_documento,
          c_digital_numero_banco: numeroBanco,
          c_digital_numero_agencia: numeroAgencia,
          c_digital_conta: numeroConta,
        })
        toast.success('Conta bancária cadastrada com sucesso!');
        setMensagemFim(true)
        setDadosBancarios(false)
      } catch (error) {
        console.log(error);
        toast.error('Erro ao cadastrar conta bancária');
      } finally {
        setLoading(false);
      }
    } else
      toast.error('Preencha todos os campos')
  }

  useEffect(() => {
    const listAllBanks = async () => {
      try {
        const { data } = await Axios.get('https://brasilapi.com.br/api/banks/v1')
        const bankItems = data.map((i) => ({ label: i.fullName, value: i.code !== null ? String(i.code).padStart(3, '0') : null, className: classNames(i.code === null ? ('hidden') : ('')) }))
        setBankList(bankItems);
      } catch (error) {
        toast.error('Serviço de consulta de bancos indisponivel, tente novamente mais tarde')
      }
    }
    listAllBanks()
  }, [])

  return (
    <div className="grid pb-[4vh] overflow-auto cadastro">
      {showSelfie && <WebCamDialog visible={true} close={() => setShowSelfie(false)} upload={(e) => handleSelfieUpload(e)} />}
      <div className="grid w-full pl-4 pr-4">
        <div className="w-full text-center">
          <form >
            <div className="grid w-full gap-4">
              {!mensagemFim && !dadosBancarios && (<>
                <ProgressBar value={75} color='#4aa677' />
                <h3 className="text-2xl">Agora precisamos de alguns documentos</h3></>)}
              {!mensagemFim && dadosBancarios &&
                (<><ProgressBar value={90} color='#4aa677' />
                  <h3 className="text-2xl">Para terminar precisamos de informações sobre a sua conta bancária</h3></>)}
              {mensagemFim &&
                (<><ProgressBar value={100} color='#4aa677' />
                  <h3 className="text-2xl">{getLocal('nomecadastro')} cadastrado com sucesso!</h3></>)}
              {selfie && <>
                <h5 className="text-xl">Primeiro precisamos de uma selfie, de uma foto somente do seu rosto para o cadastro</h5>
                <div>
                  <div className="flex justify-center m-2">
                    <div className="w-1/3" >
                      <Button
                        severity="warning"
                        type="button"
                        label="Tirar Foto"
                        icon={<FaCamera/>}
                        onClick={() => setShowSelfie(true)}
                      />
                    </div>
                  </div>
                  <FileUpload
                    ref={fileInput}
                    name="demo[]"
                    chooseLabel="Escolher"
                    chooseOptions={{                 
                      style: {
                        cursor: !onlyOneItemRule && 'pointer',
                        opacity: onlyOneItemRule && '0.6',
                        pointerEvents: onlyOneItemRule && 'none',
                        width: '100%'
                      } 
                    }}
                    onClear={() => setOnlyOneItemRule(false)}
                    onSelect={() => { setOnlyOneItemRule(true) }}
                    onProgress={() => setOnlyOneItemRule(false)}
                    onValidationFail={() => { setOnlyOneItemRule(false) }}
                    uploadLabel="Enviar"
                    uploadOptions={{ 
                      style: {
                        backgroundColor: '#4aa677',
                        borderColor: '#4aa677',
                        width: '100%'
                      }
                    }}
                    cancelLabel="Cancelar"
                    cancelOptions={{ 
                      style: {
                        backgroundColor: '#f87171',
                        borderColor: '#f87171',
                        width: '100%'
                      }
                    }}
                    customUpload
                    itemTemplate={itemTemplate}
                    uploadHandler={e => handleSelfieUpload(e.files[0])}
                    style={{ display: 'flex', flexDirection: 'column-reverse' }}
                    accept=".jpeg, .jpg, .pdf"
                    invalidFileSizeMessageDetail="o tamanho máximo do arquivo deve ser de {0}"
                    invalidFileSizeMessageSummary="{0}: Tamanho de arquivo inválido"
                    maxFileSize={3000000}
                    emptyTemplate={
                      <>
                        {/* <i className="pi pi-file text-black-alpha-60 text-8xl p-4 border-700 border-circle border-2 " /> */}
                        <p className="p-m-0">
                          *Clique em Escolher para escolher o arquivo para ser enviado</p>
                        <p>*Depois em Enviar para enviar o arquivo, caso tenha escolhido errado
                          clique em Cancelar e em Escolher para escolher novamente
                        </p>
                        <p>*Formatos de arquivo aceitos: .jpeg, .jpg .pdf</p>
                        <p>*Tamanho máximo 3MB</p>
                      </>
                    }
                  />
                </div>
              </>}
              {identificacao && <>
                <h5 className="mb-2">Agora precisamos de um documento com foto (RG, CPF ou CNH)</h5>
                  <FileUpload
                    ref={fileInput}
                    name="demo[]"
                    chooseLabel="Escolher"
                    chooseOptions={{                 
                      style: {
                        cursor: !onlyOneItemRule && 'pointer',
                        opacity: onlyOneItemRule && '0.6',
                        pointerEvents: onlyOneItemRule && 'none',
                        width: '100%'
                      } 
                    }}
                    onClear={() => setOnlyOneItemRule(false)}
                    onSelect={() => { setOnlyOneItemRule(true) }}
                    onProgress={() => setOnlyOneItemRule(false)}
                    onValidationFail={() => { setOnlyOneItemRule(false) }}
                    uploadLabel="Enviar"
                    uploadOptions={{ 
                      style: {
                        backgroundColor: '#4aa677',
                        borderColor: '#4aa677',
                        width: '100%'
                      }
                    }}
                    cancelLabel="Cancelar"
                    cancelOptions={{ 
                      style: {
                        backgroundColor: '#f87171',
                        borderColor: '#f87171',
                        width: '100%'
                      }
                    }}
                    customUpload
                    itemTemplate={itemTemplate}
                    uploadHandler={handleDocumentUpload}
                    style={{ display: 'flex', flexDirection: 'column-reverse' }}
                    accept=".jpeg, .jpg, .pdf"
                    invalidFileSizeMessageDetail="o tamanho máximo do arquivo deve ser de {0}"
                    invalidFileSizeMessageSummary="{0}: Tamanho de arquivo inválido"
                    maxFileSize={3000000}
                    emptyTemplate={
                      <>
                        {/* <i className="pi pi-file text-black-alpha-60 text-8xl p-4 border-700 border-circle border-2 " /> */}
                        <p className="p-m-0">
                          *Clique em Escolher para escolher o arquivo para ser enviado</p>
                        <p>*Depois em Enviar para enviar o arquivo, caso tenha escolhido errado
                          clique em Cancelar e em Escolher para escolher novamente
                        </p>
                        <p>*Formatos de arquivo aceitos: .jpeg, .jpg .pdf</p>
                        <p>*Tamanho máximo 3MB</p>
                      </>
                    }
                  />
              </>}
              {residencia && <>
                <h5 className="mb-2">Agora precisamos de um comprovante de residência (Conta de água, luz ou telefone)</h5>
                  <FileUpload
                    ref={fileInput}
                    name="demo[]"
                    chooseLabel="Escolher"
                    chooseOptions={{                 
                      style: {
                        cursor: !onlyOneItemRule && 'pointer',
                        opacity: onlyOneItemRule && '0.6',
                        pointerEvents: onlyOneItemRule && 'none',
                        width: '100%'
                      } 
                    }}
                    onClear={() => setOnlyOneItemRule(false)}
                    onSelect={() => { setOnlyOneItemRule(true) }}
                    onProgress={() => setOnlyOneItemRule(false)}
                    onValidationFail={() => { setOnlyOneItemRule(false) }}
                    uploadLabel="Enviar"
                    uploadOptions={{ 
                      style: {
                        backgroundColor: '#4aa677',
                        borderColor: '#4aa677',
                        width: '100%'
                      }
                    }}
                    cancelLabel="Cancelar"
                    cancelOptions={{ 
                      style: {
                        backgroundColor: '#f87171',
                        borderColor: '#f87171',
                        width: '100%'
                      }
                    }}
                    customUpload
                    itemTemplate={itemTemplate}
                    uploadHandler={handleDocumentUpload}
                    style={{ display: 'flex', flexDirection: 'column-reverse' }}
                    accept=".jpeg, .jpg, .pdf"
                    invalidFileSizeMessageDetail="o tamanho máximo do arquivo deve ser de {0}"
                    invalidFileSizeMessageSummary="{0}: Tamanho de arquivo inválido"
                    maxFileSize={3000000}
                    emptyTemplate={
                      <>
                        {/* <i className="pi pi-file text-black-alpha-60 text-8xl p-4 border-700 border-circle border-2 " /> */}
                        <p className="p-m-0">
                          *Clique em Escolher para escolher o arquivo para ser enviado</p>
                        <p>*Depois em Enviar para enviar o arquivo, caso tenha escolhido errado
                          clique em Cancelar e em Escolher para escolher novamente
                        </p>
                        <p>*Formatos de arquivo aceitos: .jpeg, .jpg .pdf</p>
                        <p>*Tamanho máximo 3MB</p>
                      </>
                    }
                  />
              </>}
              {cnpj && <>
                <h5 className="mb-2">Agora precisamos do comprovante de inscrição e situação cadastral (CNPJ)</h5>
                  <FileUpload
                    ref={fileInput}
                    name="demo[]"
                    chooseLabel="Escolher"
                    chooseOptions={{                 
                      style: {
                        cursor: !onlyOneItemRule && 'pointer',
                        opacity: onlyOneItemRule && '0.6',
                        pointerEvents: onlyOneItemRule && 'none',
                        width: '100%'
                      } 
                    }}
                    onClear={() => setOnlyOneItemRule(false)}
                    onSelect={() => { setOnlyOneItemRule(true) }}
                    onProgress={() => setOnlyOneItemRule(false)}
                    onValidationFail={() => { setOnlyOneItemRule(false) }}
                    uploadLabel="Enviar"
                    uploadOptions={{ 
                      style: {
                        backgroundColor: '#4aa677',
                        borderColor: '#4aa677',
                        width: '100%'
                      }
                    }}
                    cancelLabel="Cancelar"
                    cancelOptions={{ 
                      style: {
                        backgroundColor: '#f87171',
                        borderColor: '#f87171',
                        width: '100%'
                      }
                    }}
                    customUpload
                    itemTemplate={itemTemplate}
                    uploadHandler={handleDocumentUpload}
                    style={{ display: 'flex', flexDirection: 'column-reverse' }}
                    accept=".jpeg, .jpg, .pdf"
                    invalidFileSizeMessageDetail="o tamanho máximo do arquivo deve ser de {0}"
                    invalidFileSizeMessageSummary="{0}: Tamanho de arquivo inválido"
                    maxFileSize={3000000}
                    emptyTemplate={
                      <>
                        {/* <i className="pi pi-file text-black-alpha-60 text-8xl p-4 border-700 border-circle border-2 " /> */}
                        <p className="p-m-0">
                          *Clique em Escolher para escolher o arquivo para ser enviado</p>
                        <p>*Depois em Enviar para enviar o arquivo, caso tenha escolhido errado
                          clique em Cancelar e em Escolher para escolher novamente
                        </p>
                        <p>*Formatos de arquivo aceitos: .jpeg, .jpg .pdf</p>
                        <p>*Tamanho máximo 3MB</p>
                      </>
                    }
                  />
              </>}
              {atividade && <>
                <h5 className="mb-2">Agora precisamos do seu comprovante de atividade (Nota Fiscal, Alvará ou cartão de visitas)</h5>
                  <FileUpload
                    ref={fileInput}
                    name="demo[]"
                    chooseLabel="Escolher"
                    chooseOptions={{                 
                      style: {
                        cursor: !onlyOneItemRule && 'pointer',
                        opacity: onlyOneItemRule && '0.6',
                        pointerEvents: onlyOneItemRule && 'none',
                        width: '100%'
                      } 
                    }}
                    onClear={() => setOnlyOneItemRule(false)}
                    onSelect={() => { setOnlyOneItemRule(true) }}
                    onProgress={() => setOnlyOneItemRule(false)}
                    onValidationFail={() => { setOnlyOneItemRule(false) }}
                    uploadLabel="Enviar"
                    uploadOptions={{ 
                      style: {
                        backgroundColor: '#4aa677',
                        borderColor: '#4aa677',
                        width: '100%'
                      }
                    }}
                    cancelLabel="Cancelar"
                    cancelOptions={{ 
                      style: {
                        backgroundColor: '#f87171',
                        borderColor: '#f87171',
                        width: '100%'
                      }
                    }}
                    customUpload
                    itemTemplate={itemTemplate}
                    uploadHandler={handleDocumentUpload}
                    style={{ display: 'flex', flexDirection: 'column-reverse' }}
                    accept=".jpeg, .jpg, .pdf"
                    invalidFileSizeMessageDetail="o tamanho máximo do arquivo deve ser de {0}"
                    invalidFileSizeMessageSummary="{0}: Tamanho de arquivo inválido"
                    maxFileSize={3000000}
                    emptyTemplate={
                      <>
                        {/* <i className="pi pi-file text-black-alpha-60 text-8xl p-4 border-700 border-circle border-2 " /> */}
                        <p className="p-m-0">
                          *Clique em Escolher para escolher o arquivo para ser enviado</p>
                        <p>*Depois em Enviar para enviar o arquivo, caso tenha escolhido errado
                          clique em Cancelar e em Escolher para escolher novamente
                        </p>
                        <p>*Formatos de arquivo aceitos: .jpeg, .jpg .pdf</p>
                        <p>*Tamanho máximo 3MB</p>
                      </>
                    }
                  />
              </>}
              {!mensagemFim && dadosBancarios && <>
                <form className="mt-4" >
                  <div className="px-3 grid gap-7 w-full">
                    <div className="grid w-full">
                      <Dropdown
                        value={numeroBanco}
                        options={bankList}
                        emptyMessage='Selecione o Banco'
                        placeholder="Selecione o Banco"
                        optionLabel="label"
                        optionValue='value'
                        filter
                        className="w-full"
                        pt={DropdownPague}
                        filterBy='label'
                        showFilterClear
                        required
                        scrollHeight='30em'
                        onChange={e => setNumeroBanco(e.value)} />
                    </div>

                    <FloatLabel className="w-full grid">

                      <InputText
                        id="conta_numero_banco"
                        name="conta_numero_banco"
                        className="w-full"
                        onChange={e => setNumeroBanco(e.target.value)}
                        value={numeroBanco}
                        tooltip='Com os zeros a esquerda'
                        tooltipOptions={{ position: 'bottom' }}
                        required
                        useGrouping={false}
                      />
                      <label htmlFor="conta_numero_banco">
                        Código do Banco
                      </label>
                    </FloatLabel>

                    <FloatLabel pt={FloatLabelNumber} className="w-full grid">

                      <InputNumber
                        id="c_digital_numero_agencia"
                        name="c_digital_numero_agencia"
                        pt={InputNumberPague}
                        onChange={e => setNumeroAgencia(e.value)}
                        value={numeroAgencia}
                        required
                        min={0}
                        useGrouping={false}
                      />
                      <label htmlFor="c_digital_numero_agencia">
                        Número da agência bancária
                      </label>
                    </FloatLabel>

                    <FloatLabel pt={FloatLabelNumber} className="w-full grid">
                      {/* <p>Com o digito verificador, sem os zeros a esquerda</p> */}
                      <InputNumber
                        id="c_digital_numero_conta"
                        name="c_digital_numero_conta"
                        pt={InputNumberPague}
                        onChange={e => setNumeroConta(e.value)}
                        tooltip='Com o digito verificador, sem os zeros a esquerda'
                        tooltipOptions={{ position: 'bottom' }}
                        value={numeroConta}
                        required
                        min={0}
                        useGrouping={false}
                      />
                      <label htmlFor="c_digital_numero_conta">
                        Número da Conta
                      </label>
                    </FloatLabel>
                  </div>

                  <div className="w-full flex justify-center mt-5">
                    <div className="grid w-full md:w-1/3 ">
                      <Button
                        className="w-full"
                        severity="success"
                        type="button"
                        label="Continuar"
                        onClick={() => addBankAccount()}
                        loading={loading}
                      />
                    </div>
                  </div>

                </form>
              </>}
              {mensagemFim && !dadosBancarios && <h3 className="text-lg">
                Cadastro concluído com sucesso, dentro de 24 horas entraremos em contato com mais informações sobre o seu cadastro!
              </h3>}
              {!mensagemFim && <>
                {/* <p><small>*Envie apenas um arquivo</small></p> */}
                {/* <small>*Para continuar envie um arquivo</small> */}
                <div className="flex justify-center">
                  <div className="w-1/3" >
                    <Button icon={<BiRefresh className="text-2xl" />}
                      severity="danger"
                      label="Refazer"
                      className="w-full"
                      tooltip="Refazer cadastro"
                      tooltipOptions={{ position: 'bottom' }}
                      onClick={() => { localStorage.clear(); navigate('/cadastro/passo0') }} />
                  </div>
                </div>
              </>}
              {(documentosEnviados[0] && !mensagemFim) && <>
                <div className="card mt-4">
                  <h5>Documentos já enviados</h5>
                  {documentosEnviados.map((e, key) => {
                    return (<Tag id={key} className="ml-2 text-md p-2">
                      {e === 'identificacao' && ('Documento de Identificação')}
                      {e === 'selfie' && ('Foto do Rosto')}
                      {e === 'residencia' && ('Comprovante de Residência')}
                    </Tag>)
                  })}
                </div>
              </>}
              {mensagemFim &&
                <div className="flex justify-center w-full mt-6">
                    <Button
                      label="Continuar"
                      className="w-2/3"
                      severity="success"
                      //type="submit"
                      onClick={() => { localStorage.clear(); navigate('/login') }}
                    //disabled={!aceite}
                    />
                </div>}

            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ZoopCadastro